import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios"; // Make sure you import axios
import { Row, Col, Container } from "react-bootstrap";
import Header from "../components/Header";
import Footer from "../components/Footer";
import LikeGirl from "../assets/Images/maylikegirl.avif";
import "swiper/css";
import "swiper/css/navigation";
import { Swiper, SwiperSlide } from "swiper/react";
import { enqueueSnackbar } from "notistack";
import { FadeLoader } from "react-spinners";

const CatalogDetails = () => {
  const { slug } = useParams(); // Get slug from URL
  const navigate = useNavigate(); // Initialize useNavigate hook
  const [catalog, setCatalog] = useState(null);
  const [relatedCatalogs, setRelatedCatalogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedSlide, setSelectedSlide] = useState();

  const slides = [
    <img src={LikeGirl} alt={"asd"} />,
    <img src={LikeGirl} alt={"asd"} />,
    <img src={LikeGirl} alt={"asd"} />,
    <img src={LikeGirl} alt={"asd"} />,
  ];

  const handleSlideClick = (content) => {
    setSelectedSlide(content);
  };

  // Function to fetch catalog data
  const fetchCatalog = async () => {
    try {
      const response = await axios.get(
        `https://naqshzari.com/backend/public/api/get-catalog-by-slug/${slug}`,
        {
          headers: {
            Accept: "application/json",
          },
        }
      );
      if (response.data.status === 200) {
        const catalogData = response.data.data;
        setCatalog(catalogData);
        setSelectedSlide(catalogData.image);
        setRelatedCatalogs(response.data.related_products);
      } else {
        enqueueSnackbar("Internal Server Error", {
          variant: "error",
          autoHideDuration: 2000,
        });
      }
    } catch (error) {
      enqueueSnackbar("Internal Server Error", {
        variant: "error",
        autoHideDuration: 2000,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchCatalog(); // Fetch catalog data when component mounts
  }, [slug]); // Dependency array to refetch if slug changes

  return (
    <>
      <Header />
      <div className="catalog-details-section">
        <Container>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <FadeLoader
              color={"#000000"}
              loading={loading}
              width={3}
              height={10}
            />
          </div>
          {catalog && (
            <Row className="mb-5">
              <Col md={5}>
                <div className="main-bride">
                  {/* <img src={catalog.image} alt={catalog.title} /> */}
                  <img src={selectedSlide} alt={catalog.title} />
                  <div className="mt-2">
                    {/* Swiper container */}
                    <Swiper spaceBetween={10} slidesPerView={3}>
                      {/* Primary catalog image as the first slide */}
                      <SwiperSlide>
                        <img
                          src={catalog.image}
                          alt="Primary Catalog"
                          onClick={() => handleSlideClick(catalog.image)}
                          style={{ cursor: "pointer", width: "100%" }}
                        />
                      </SwiperSlide>
                      {/* Additional catalog images */}
                      {catalog.catalog_images.map((image) => (
                        <SwiperSlide key={image.id}>
                          <img
                            src={image.img}
                            alt="Catalog"
                            onClick={() => handleSlideClick(image.img)}
                            style={{ cursor: "pointer", width: "100%" }}
                          />
                        </SwiperSlide>
                      ))}
                    </Swiper>

                    {/* Div to display selected slide */}
                  </div>
                </div>
              </Col>
              <Col md={7}>
                <div className="product-data">
                  <div className="share-icon-line">
                    <div className="product-name">{catalog.title}</div>
                  </div>
                  <div className="product-desc">
                    {catalog.description}
                    <br />
                    <br />
                    Fabric: {catalog.fabric}
                    <br />
                    Color: {catalog.color}
                    {catalog.category && (
                      <>
                        <br />
                        Category: {catalog.category.title}
                      </>
                    )}
                    <br />
                    <br />
                    The ensemble is complemented by Naqshzari. For enquiries,
                    please contact support@naqshzari.com or call +923008220544.
                  </div>
                </div>
                <div
                  className="product-data product-desc"
                  style={{ color: "rgb(0 128 0)" }}
                >
                  Made to order: 7 - 8 Weeks
                </div>
                <div className="btn-lines product-data product-desc">
                  <div
                    className="enquire-btn"
                    onClick={() => navigate("/contact")}
                  >
                    Enquire
                  </div>
                </div>
              </Col>
            </Row>
          )}
          {/* You May Also Like Section */}
          {relatedCatalogs.length > 0 && (
            <div className="you-also-like">
              <div className="heading">You May Also Like</div>
              <Swiper
                className="mySwiper"
                slidesPerView={4.5}
                loop={true}
                spaceBetween={20}
              >
                {relatedCatalogs.map((catalog, index) => {
                  return (
                    <SwiperSlide key={index}>
                      <div
                        className="img-size-like"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          navigate(`/catalog-details/${catalog.slug}`)
                        }
                      >
                        <img src={catalog.image} />
                        <div className="dress-title">{catalog.title}</div>
                      </div>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            </div>
          )}
        </Container>
        <Footer />
      </div>
    </>
  );
};

export default CatalogDetails;
